import axios from '../axios'

/* 
 * 视频管理
 */
//查询
export const getListApi = (params) => {
  return axios({
      url: '/video/list',
      method: 'get',
      params
  })
}
// 新增
export const addApi = data => {
  return axios({
      url: '/video',
      method: 'post',
      data
  })
}
//更新
export const updateApi = data => {
  return axios({
      url: '/video',
      method: 'put',
      data
  })
}
//删除
export const deleteApi= (id) => {
  return axios({
      url: `/video/${id}`,
      method: 'delete',
      // params
  })
}
//批量删除试卷
export const deleteBatchApi= (ids) => {
  return axios({
      url: `/video/batch/${ids}`,
      method: 'delete',
      // params
  })
}


// WEBPACK FOOTER //
// ./src/http/api/video.js